import { chakra, shouldForwardProp } from '@chakra-ui/react';
import { isValidMotionProp, motion, SVGMotionProps } from 'framer-motion';
import { ComponentProps } from 'react';

export const MotionBox = chakra(motion.div, {
    /**
     * Allow motion props and non-Chakra props to be forwarded.
     */
    shouldForwardProp: (prop) =>
        isValidMotionProp(prop) || shouldForwardProp(prop),
});

export type MotionBoxProps = ComponentProps<typeof MotionBox>;

export const MotionSVG = chakra(motion.svg, {
    /**
     * Allow motion props and non-Chakra props to be forwarded.
     */
    shouldForwardProp: (prop) =>
        isValidMotionProp(prop) || shouldForwardProp(prop),
});

export type MotionSVGProps = ComponentProps<typeof MotionSVG> &
    SVGMotionProps<SVGSVGElement>;

export const MotionPath = chakra(motion.path, {
    /**
     * Allow motion props and non-Chakra props to be forwarded.
     */
    shouldForwardProp: (prop) =>
        isValidMotionProp(prop) || shouldForwardProp(prop),
});

export type MotionPathProps = ComponentProps<typeof MotionPath> &
    SVGMotionProps<SVGPathElement>;
